import lazyLoading from './config';
import ErrorRouter from './error.router';
import ApiDocRouter from './apiDoc.router';
import ControlRouter from './control.router';

const routers = [
    {
        path: '/docCenter',
        name: 'docCenter',
        meta: {
            title: '文档中心'
        },
        component: resolve => lazyLoading(resolve, 'docCenter')
    },
    {
        path: '/notice',
        name: 'notice',
        meta: {
            title: '平台公告'
        },
        component: resolve => lazyLoading(resolve, 'notice')
    },
    {
        path: '/trade',
        name: 'trade',
        meta: {
            title: 'trade'
        },
        component: resolve => lazyLoading(resolve, 'trade')
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: resolve => lazyLoading(resolve, 'login')
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '注册'
        },
        component: resolve => lazyLoading(resolve, 'register')
    },
    {
        path: '/sign',
        name: 'sign',
        meta: {
            title: '生成签名'
        },
        component: resolve => lazyLoading(resolve, 'sign')
    },
    {
        path: '*',
        redirect: '/404'
    },
    ...ErrorRouter,
    ...ApiDocRouter,
    ...ControlRouter
];

export default routers;
